import * as yandex from './yandex.json';
import getYandexTurboId from '../../../webpack/utils/configs-app/getYandexTurboId';

export const YMAP_APIKEY = '6be8f89a-55f0-41e5-849f-b320ba4c9cbd';

export const YANDEX_TURBO_APP_ID = getYandexTurboId.yandexTurboId;
export const YANDEX_TURBO_AVATAR_PATH = yandex.turboAvatarPath;
